import {inject, Injectable} from "@angular/core";
import {Overlay, OverlayRef} from "@angular/cdk/overlay";
import {ComponentPortal} from "@angular/cdk/portal";
import {BlockUiComponent} from "../block-ui.component";

@Injectable({
	providedIn: "root"
})
export class BlockUiService {

	private readonly overlay: Overlay = inject(Overlay);

	private overlayRef: OverlayRef | null = null;
	private isVisible: boolean | false = false;

	public blockUi(): void {
		if (!this.isVisible) {
			this.overlayRef = this.overlay.create({
				hasBackdrop: true,
				backdropClass: 'cdk-overlay-dark-backdrop',
				panelClass: 'block-ui-overlay',
				positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
			});

			this.overlayRef.attach(new ComponentPortal(BlockUiComponent));

			this.isVisible = true;
		}
	}

	public unblockUi(): void {
		if (this.overlayRef && this.isVisible) {
			this.overlayRef.detach();
			this.isVisible = false;
		}
	}
}